import * as styles from '@classification-testing/components/ClassificationResultItem.css';
import type { ClassificationResult } from '@classification-testing/domain';
import { ContentType } from '@classification-testing/domain';
import { InlineAudioPlayer } from '@core/components';
import { BlurToggle } from '@soteria/design-system-ve';

interface ClassificationCardControlsProps {
  result: ClassificationResult;
  isSafe: boolean;
  isContentBlurred: boolean;
  onToggleBlur: (e: React.MouseEvent) => void;
  mediaServiceUrl?: string;
}

/**
 * Controls section with audio player and blur toggle
 */
export function ClassificationCardControls({ result, isSafe, isContentBlurred, onToggleBlur, mediaServiceUrl }: ClassificationCardControlsProps) {
  return (
    <div className={styles.metadataRightSection}>
      {result.contentType === ContentType.AUDIO && result.contentUrl && (
        <div className={styles.audioPlayerSection}>
          <InlineAudioPlayer audioId={result.id} audioUrl={result.contentUrl} mediaServiceUrl={mediaServiceUrl} transcription={result.text} />
        </div>
      )}
      {!isSafe && <BlurToggle isBlurred={isContentBlurred} onToggle={onToggleBlur} />}
    </div>
  );
}
